import styled, { css } from 'styled-components'
import { ThemeSelectors, TypeFiesta, TypePhantom } from '@at/design-system-foundation'
import { Button, CheckBox } from '@at/design-system-elements'

export const StyledSaveSearchModalWrapper = styled.div`
    margin: 0 auto ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
    max-width: 341px;
    text-align: center;
    && * {
        transition: none;
    }
`

export const StyledBoldFont = styled.span`
    font-variation-settings: 'wght' 500;
`

export const StyledSaveSearchVerificationModalWrapper = styled.div`
    margin: 0 auto ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
    max-width: 441px;
    text-align: left;
    && * {
        transition: none;
    }
`
export const StyledSaveSearchVerificationModalTitle = styled(TypePhantom)`
    color: ${({ theme }) => theme.color.text.title};
    font-size: 26px;
    font-weight: 400;
    text-align: left;
    line-height: 24px;
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`

export const StyledSaveSearchVerificationModalText = styled(TypeFiesta)`
    text-align: left;
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
`
export const StyledSaveSearchModalTitle = styled(TypePhantom)`
    color: ${({ theme }) => theme.color.text.title};
    font-size: 26px;
    font-weight: 400;
    text-align: center;
    line-height: 24px;
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`
export const StyledSaveSearchModalText = styled(TypeFiesta)`
    text-align: center;
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
`

export const StyledSaveSearchFormContainer = styled.div`
    ${({ theme }) => css`
        & .atds-field {
            margin-bottom: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme)}px;
        }
        & .atds-field__label {
            text-align: left;
        }
        & .atds-field__error-text {
            text-align: left;
        }

        & div:nth-child(3) {
            & .atds-field__label {
                margin: ${ThemeSelectors.getGroupOneSpacing(theme)} 0 ${ThemeSelectors.getGroupFourSpacing(theme)} 0;
                justify-content: start;
                gap: ${ThemeSelectors.getGridUnit(theme)};
            }
        }
    `}
`

export const StyledCharacterCounter = styled(TypeFiesta)`
    color: ${({ theme }) => theme.color.text.default};
    display: block;
    text-align: left;
    font-size: 14px;
`
export const StyledSaveSearchAlert = styled(CheckBox)`
    text-align: left;
    margin: 6px 0;
`
export const StyledPanelButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`

export const StyledPanelSaveSearchButton = styled(Button)`
    clear: both;
    display: block;
    margin: auto;
    color: ${({ theme }) => theme.color.button.text.primary.default};
    padding: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)}px
        ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)}px;
`
